import React from "react";

const FeaturedTableCheckbox = ({ isFeatured, onToggle, disabled = false }) => (
  <label className="inline-flex items-center justify-center gap-2 cursor-pointer select-none">
    <input
      type="checkbox"
      checked={!!isFeatured}
      disabled={disabled}
      onClick={(e) => {
        e.preventDefault();
        onToggle();
      }}
      readOnly
      className="w-4 h-4 accent-[#FE7B38] cursor-pointer"
      title={isFeatured ? "Featured" : "Not featured"}
    />
    <span className="text-xs text-gray-600">{isFeatured ? "Featured" : "Add to Feature"}</span>
  </label>
);

export default FeaturedTableCheckbox;
